// Shared grid template — the header (`winners-feed-list-header`) and every
// desktop row MUST use this so columns line up. Columns:
// winning outcome | price | 1h | 24h | total volume | graduated | market cap | last 7 days.
// (No rank column — winners are not numbered.) The graduated column is 5rem so
// the "Graduated" header fits without overflowing into Volume.
//
// This lives in a NEUTRAL (non-`'use client'`) module on purpose: the desktop
// row skeleton (`winners-feed-skeleton`) is SERVER-rendered via the route-level
// `loading.tsx`, so it imports this constant directly. A value exported from a
// `'use client'` module becomes a client-reference proxy when imported into a
// Server Component, which `cn()` silently drops — collapsing the grid to a
// single column. Keeping the string here makes it a plain value usable from
// both server and client.
export const WINNERS_ROW_GRID_CLASS =
  'grid-cols-[minmax(0,1fr)_5rem_4.5rem_4.5rem_7rem_5rem_7rem_8.5rem] gap-3 items-center' as const;
